var _linearGradient, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 37.087,
    x2: 10.76,
    y1: 10.967,
    y2: 37.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6560fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#6f6afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#9a97fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.362,
    stopColor: "#bfbdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#dbdaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#efeeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#fbfbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.924,
    cy: 24.13,
    r: 18.615,
    fill: "url(#SVGID_1_)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8251fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35.054,38.836C31.97,41.137,28.144,42.5,24,42.5C13.783,42.5,5.5,34.217,5.5,24 c0-2.917,0.675-5.676,1.878-8.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8251fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M13.869,8.518C16.779,6.61,20.26,5.5,24,5.5c10.217,0,18.5,8.283,18.5,18.5c0,2.941-0.686,5.721-1.907,8.19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8251fe",
    d: "M34,23c0-1.574-0.576-3.038-1.558-4.275c0.442-1.368,0.93-3.771-0.242-5.648c-2.251,0-3.73,1.545-4.436,2.514 C26.602,15.213,25.333,15,24,15s-2.602,0.213-3.764,0.591c-0.706-0.969-2.184-2.514-4.436-2.514c-1.328,2.126-0.526,4.45-0.073,5.43 C14.638,19.788,14,21.334,14,23c0,3.78,3.281,6.94,7.686,7.776c-1.309,0.673-2.287,1.896-2.587,3.38h-1.315 c-1.297,0-1.801-0.526-2.502-1.415c-0.692-0.889-1.437-1.488-2.331-1.736c-0.482-0.051-0.806,0.316-0.386,0.641 c1.419,0.966,1.516,2.548,2.085,3.583C15.168,36.161,16.229,37,17.429,37H19v5.942h10v-7.806c0-1.908-1.098-3.544-2.686-4.36 C30.719,29.94,34,26.78,34,23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.47fd7b4989a431dea1f9dac6f2daedde.svg";
export { ForwardRef as ReactComponent };